import { CTabreakModulePropertiesModel } from '@/client';
import { HeadingTag, Link, ModuleBase, ResponsiveImage, Text } from '@/components';
import classNames from 'classnames';
import React from 'react';

const CTABreakModule = ({ data, moduleName }: { data: CTabreakModulePropertiesModel; moduleName: string }) => {
  return (
    <ModuleBase data={data} moduleName={moduleName}>
      <div className="main-wrapper container flex items-center gap-6 max-md:flex-col md:justify-between lg:gap-10">
        {data.image && (
          <div className="logo size-[100px] shrink-0 md:size-40" data-cy="image">
            <ResponsiveImage image={data.image[0]} widths={{ xs: 99, sm: 99, md: 120, lg: 120, xl: 120, xxl: 120 }} />
          </div>
        )}

        <div className="flex w-full max-lg:flex-col lg:justify-between">
          <div
            className={classNames(
              'flex flex-col gap-4 lg:w-2/3',
              data.primaryCTA || data.secondaryCTA ? 'mb-10 lg:mb-0' : 'mb-0',
            )}
          >
            {data.preHeading && (
              <Text className="text-xs uppercase text-white/50 md:text-sm" data-cy="preheading-tag">
                {data.preHeading}
              </Text>
            )}

            {data.headingTitle && (
              <HeadingTag
                data={{ heading: data.headingTitle }}
                className="text-3xl md:text-5xl"
                data-cy="ctabreak-heading"
              />
            )}
          </div>

          {(data.primaryCTA || data.secondaryCTA) && (
            <div className="flex justify-end gap-4 lg:items-center">
              {data.primaryCTA && (
                <Link
                  className="inline-flex h-10 items-center rounded-md border px-3 py-2 text-sm hover:bg-white hover:text-black"
                  data-cy="ctabreak-primary-cta"
                  link={data.primaryCTA[0]}
                />
              )}
              {data.secondaryCTA && (
                <Link
                  className="inline-flex h-10 items-center rounded-md border border-white/25 px-3 py-2 text-sm hover:bg-white/25 hover:text-white"
                  data-cy="ctabreak-secondary-cta"
                  link={data.secondaryCTA[0]}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </ModuleBase>
  );
};

export default CTABreakModule;
